/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import { Fragment, useEffect, useState } from "react";
import { exists, isTrue } from "cms/utils/empty-exists";
import { IconLinkItem } from "./icon-link-item";

const IconLinkTabContent = (props) => {

    const tab = props?.tab;
    const iconLinks = tab?.icon_links;
    const tabVisible = tab?.isVisible;

    const [isVisible, setIsVisible] = useState(tabVisible);

    useEffect(() => {
        setIsVisible(tabVisible);
    }, [tabVisible]);

    return (
        <Fragment>
            {isTrue(isVisible) && exists(tab) && (
                <div
                    className="icon-link-tab-content"
                    data-tab-index="1"
                    role="tabpanel"
                    id={tab.guid}
                    aria-hidden="false"
                >
                    {iconLinks.map((iconLink) => {
                        const guid = iconLink?.guid;
                        return (
                            <IconLinkItem iconLink={iconLink} key={guid} />
                        );
                    })}
                </div>
            )}
        </Fragment>
    );
};

IconLinkTabContent.displayName = "IconLinkTabContent";
export { IconLinkTabContent }; 